import type {Rec, Document} from 'src/typings';
import type {TabGroup} from 'src/features/erp/components/erp-tab-pages/types';
import {FOND_PROJECT} from 'src/features/erp-sutor/sutor-fonds';
import {
    RECORD_DETAIL_DETAILS_TAB,
    RECORD_DETAIL_TOOLS_TAB
} from 'src/features/erp-sutor/features/generic-record-detail';
import {exists} from 'shared/utils/custom-utils';
import ProjectRecordDetailInfoTab from './tab-pages/ProjectRecordDetailInfoTab.svelte';
import ProjectRecordDetailFinancialOverviewTab from './tab-pages/ProjectRecordDetailFinancialOverviewTab.svelte';
import GenericRecordDetailDebugTab from '../generic-record-detail/tab-pages/GenericRecordDetailDebugTab.svelte';
import ProjectRecordDetailAnalysisTab from './tab-pages/ProjectRecordDetailAnalysisTab.svelte';
import {
    getFirstViewableFieldByFieldTypeIdRecursive,
    getTextFromViewableField
} from 'src/features/erp-sutor/sutor-utils';
import {ProjectReportOptimisation} from 'src/features/erp-sutor/features/project-report-optimisation';
import {ProjectLogbookPairing} from 'src/features/erp-sutor/features/project-logbook-pairing';

export function getFormattedProjectNameParts(record: Rec): { name: string; projectNumber: string | null } {
    const projectNameField = getFirstViewableFieldByFieldTypeIdRecursive(record, FOND_PROJECT.projectNameFieldId);
    const projectNumberField = getFirstViewableFieldByFieldTypeIdRecursive(record, FOND_PROJECT.projectNumberFieldId);

    const projectName = getTextFromViewableField(projectNameField, null) ?? record.name;
    const projectNumber = getTextFromViewableField(projectNumberField, null);

    return {name: projectName, projectNumber};
}

export function modifyTabGroupsForProjectRecord(currentTabGroups: TabGroup[], showAnalyticsTab: boolean, record: Document): TabGroup[] {
    const tabDetail = currentTabGroups.find((group) => group.id === RECORD_DETAIL_DETAILS_TAB);
    if (exists(tabDetail)) {
        tabDetail.render = undefined;
        tabDetail.subtabs = [
            {
                id: 'tab-info',
                label: 'Detail',
                icon: 'info',
                render: {
                    component: ProjectRecordDetailInfoTab,
                    padded: true
                }
            },
            {
                id: 'tab-debug',
                label: 'Debug',
                icon: 'bug',
                render: {
                    component: GenericRecordDetailDebugTab,
                    padded: true
                }
            },
            {
                id: 'tab-reported-work',
                label: 'Hospodaření',
                icon: 'edit',
                render: {
                    component: ProjectRecordDetailFinancialOverviewTab,
                    padded: true
                }
            }
        ];

        if (showAnalyticsTab) {
            tabDetail.subtabs.push({
                id: 'tab-analysis',
                label: 'Analýza',
                icon: 'analyse',
                render: {
                    component: ProjectRecordDetailAnalysisTab
                }
            });
        }
    }

    const tabTools = currentTabGroups.find((group) => group.id === RECORD_DETAIL_TOOLS_TAB);
    if (exists(tabTools)) {
        tabTools.subtabs.push({
            id: 'tab-logbook-pairing',
            label: 'Párování MD',
            icon: 'arrows-cross',
            render: {
                component: ProjectLogbookPairing,
                props: {
                    record
                }
            }
        });

        tabTools.subtabs.push({
            id: 'tab-optimisation',
            label: 'Optimalizace',
            icon: 'money-check-edit',
            render: {
                component: ProjectReportOptimisation,
                props: {
                    record
                }
            }
        });
    }

    return currentTabGroups;
}